import { Application } from '../types'

export const applications: Application[] = [
  {
    id: 'construction',
    title: 'Građevinski objekti',
    problem:
      'Ručni transport materijala uz stepenice usporava radove i povećava rizik od povreda i oštećenja opreme.',
    solution:
      'D-TECH električna mašina za transport tereta omogućava bezbedno podizanje tereta do 250 kg uz potpunu kontrolu i stabilnost, ubrzavajući dinamiku gradilišta i smanjujući opterećenje radnika.',
    icon: 'HardHat',
  },
  {
    id: 'warehousing',
    title: 'Magacini i distribucija',
    problem:
      'Kretanje robe između spratova u objektima bez teretnog lifta stvara zastoje i povećava troškove radne snage.',
    solution:
      'Optimizujte vertikalni transport robe pouzdanim električnim transporterom koji omogućava jednoj osobi da bezbedno prenosi teške terete bez dodatne radne snage.',
    icon: 'Package',
  },
  {
    id: 'delivery',
    title: 'Dostava i kurirske službe',
    problem:
      'Isporuka bele tehnike, opreme i paketa u višespratnim zgradama je fizički zahtevna i rizična.',
    solution:
      'Električni transporter za stepenice omogućava kontrolisano kretanje tereta uz i niz stepenice, smanjujući rizik od povreda i oštećenja robe.',
    icon: 'Truck',
  },
  {
    id: 'manufacturing',
    title: 'Proizvodni pogoni',
    problem:
      'Premeštanje sirovina i gotovih proizvoda između proizvodnih nivoa usporava operacije i stvara uska grla.',
    solution:
      'D-TECH mašina za vertikalni transport obezbeđuje stabilan i kontinualan tok materijala između nivoa bez prekida proizvodnje.',
    icon: 'Factory',
  },
  {
    id: 'retail',
    title: 'Maloprodaja i HoReCa',
    problem:
      'Dopuna zaliha u višespratnim objektima opterećuje osoblje i usporava rad.',
    solution:
      'Kompaktna konstrukcija i precizna kontrola omogućavaju brzo i bezbedno premeštanje robe kroz uske prolaze i stepenice bez ometanja kupaca.',
    icon: 'Store',
  },
  {
    id: 'healthcare',
    title: 'Zdravstvene ustanove',
    problem:
      'Transport osetljive medicinske opreme zahteva maksimalnu stabilnost i kontrolu.',
    solution:
      'Električna mašina sa integrisanom kočnicom obezbeđuje siguran i kontrolisan transport osetljive opreme kroz više nivoa objekta.',
    icon: 'Heart',
  },
]
